import 'styles/index.css'

import { StyledEngineProvider } from '@mui/material/styles'
import { QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { Spinner } from 'components/spinner'
import { LocalStorageProvider } from 'contexts/local-storage-context'
import { LocalizationProvider } from 'localization'
import { queryClient } from 'queries/queries'
import React from 'react'
import ReactDOM from 'react-dom/client'
import { App } from './App'
import reportWebVitals from './reportWebVitals'

if (window.global.REACT_APP_GOOGLE_TAG_MANAGER_ID) {
  try {
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    const TagManager = require('react-gtm-module')
    TagManager.initialize({
      gtmId: window.global.REACT_APP_GOOGLE_TAG_MANAGER_ID,
    })
  } catch (error) {
    console.warn(error)
  }
}

const root = ReactDOM.createRoot(document.getElementById('foore-addon-selector') as HTMLElement)
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <React.Suspense
        fallback={
          <div
            style={{
              position: 'fixed',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
            }}>
            <Spinner />
          </div>
        }>
        <LocalStorageProvider>
          <LocalizationProvider>
            <StyledEngineProvider injectFirst>
              <App />
            </StyledEngineProvider>
            <ReactQueryDevtools initialIsOpen={false} />
          </LocalizationProvider>
        </LocalStorageProvider>
      </React.Suspense>
    </QueryClientProvider>
  </React.StrictMode>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
